import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const portalAccessGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const portalCode = route.data['portalCode'] as string | undefined;

  if (!auth.hasAccessToken()) {
    return router.parseUrl('/login');
  }

  if (!portalCode || auth.isPortalAuthorized(portalCode)) {
    return true;
  }

  const fallback = auth.firstAuthorizedRoute();
  return router.parseUrl(fallback ?? '/login');
};
